const getFullName = (firstName, middleName, lastName) =>
  firstName ? `${firstName} ${middleName ? middleName + " " : ""}${lastName}` : ""
export default getFullName
